import { render, staticRenderFns } from "./activitypackage.vue?vue&type=template&id=0e1fd51b&"
import script from "./activitypackage.vue?vue&type=script&lang=js&"
export * from "./activitypackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports